import SvgEmail from '@img/icons/envelope.svg';
import SvgFacebook from '@img/icons/facebook.svg';
import SvgLinkedIn from '@img/icons/linkedIn.svg';
import SvgShare from '@img/icons/share.svg';
import SvgTwitter from '@img/icons/twitter.svg';
import * as React from 'react';
import S from './ShareButtons.styles';
const ShareButtons = ({ options = ['facebook', 'twitter', 'linkedin', 'email'], title, url, }) => {
    const shareData = {
        title,
        url,
    };
    /*
    Disable browser share button initially. Do check on first render,
    then enable to prevent CLS issues.
    */
    const [canShare, setCanShare] = React.useState(false);
    React.useEffect(() => {
        setCanShare(typeof window != 'undefined' && window.navigator && 'share' in window.navigator);
    }, []);
    return (React.createElement(S.Container, null,
        React.createElement(S.Text, null, "Share Article:"),
        React.createElement(S.List, null,
            React.createElement(S.Item, null,
                React.createElement(S.Link, { as: "button", title: "Share", type: "button", onClick: (event) => {
                        event.preventDefault();
                        share(shareData);
                    }, disabled: !canShare },
                    React.createElement(S.Icon, { as: SvgShare }))),
            options?.map(renderButton))));
    function renderButton(option) {
        switch (option) {
            case 'email':
                return (React.createElement(S.Item, null,
                    React.createElement(S.Link, { href: getEmailUrl(shareData), rel: "noreferrer noopener", target: "_blank", title: "Share via Email" },
                        React.createElement(S.Icon, { as: SvgEmail }))));
            case 'facebook':
                return (React.createElement(S.Item, null,
                    React.createElement(S.Link, { href: getFacebookUrl(shareData), rel: "noreferrer noopener", target: "_blank", title: "Share via Facebook" },
                        React.createElement(S.Icon, { as: SvgFacebook }))));
            case 'linkedin':
                return (React.createElement(S.Item, null,
                    React.createElement(S.Link, { href: getLinkedInUrl(shareData), rel: "noreferrer noopener", target: "_blank", title: "Share via LinkedIn" },
                        React.createElement(S.Icon, { as: SvgLinkedIn }))));
            case 'twitter':
                return (React.createElement(S.Item, null,
                    React.createElement(S.Link, { href: getTwitterUrl(shareData), rel: "noreferrer noopener", target: "_blank", title: "Share via Twitter" },
                        React.createElement(S.Icon, { as: SvgTwitter }))));
            default:
                throw new Error(`Unknown share option`);
        }
    }
};
export default ShareButtons;
function getEmailUrl(data) {
    return `mailto:?subject=${data.title}&body=${data.url}`;
}
function getFacebookUrl(data) {
    return `https://www.facebook.com/sharer/sharer.php?u=${data.url}`;
}
function getLinkedInUrl(data) {
    return `https://www.linkedin.com/shareArticle?title=${data.title}&url=${data.url}`;
}
function getTwitterUrl(data) {
    return `https://twitter.com/intent/tweet?text=${data.title}&url=${data.url}`;
}
/**
 * Attempt to share using the Web Share API.
 * @param data The share data
 */
function share(data) {
    return navigator.share(data);
}
